import './styles/BlankPage.scss';

import { PropsWithChildren } from 'react';

import { useClassHelper } from '../../hooks';

const componentName = 'c-BlankPage';

interface Props extends PropsWithChildren {
  config: {
    assets: {
      logo: string;
    };
    environments: {
      settings: {
        companyFlag: string;
      };
    };
  };
  isStandAlone: boolean;
}

export const BlankPage = ({ isStandAlone, config, children }: Props) => {
  const c = useClassHelper(componentName);
  const {
    assets: { logo },
    environments: {
      settings: { companyFlag },
    },
  } = config;

  return (
    <main className={c('base')}>
      {!isStandAlone && (
        <div className={c('__logo')}>
          <img
            className={companyFlag === 'NetLync' ? `` : `${c('__logo-other')}`}
            alt="netlynclogo"
            src={logo}
          />
        </div>
      )}

      <section className={c('__content')}>{children}</section>
    </main>
  );
};
